import React from 'react';
import 'swiper/css';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Media } from '../../utils/breakpoints-helper';
import clsx from 'clsx';

enum MktCarrouselVariant {
  LIGHT = 'light',
  DARK = 'dark',
}

interface MktCarrouselProps {
  elements: any[];
  variant: `${MktCarrouselVariant}`;
}

export const MktCarrousel: React.FC<MktCarrouselProps> = ({
  elements,
  variant = 'light',
}) => {
  const isDesktop = Media().xl();
  const isTablet = Media().md();

  const getSliderPerView = () => {
    if (isTablet && !isDesktop) {
      return 2;
    } else if (isDesktop) {
      return 3;
    } else {
      return 1;
    }
  };

  const SlidePrevButton = () => {
    const swiper = useSwiper();
    const handleClick = () => {
      if (swiper.isBeginning) {
        swiper.slideTo(swiper.slides.length - 1);
      } else {
        swiper.slidePrev();
      }
    };
    return (
      <button
        type="button"
        className={clsx(
          'whl-pointer-events-auto  whl-transition-all hover:whl-opacity-75',
          { 'whl-text-blue-dark': variant === MktCarrouselVariant.DARK },
          { 'whl-text-white': variant === MktCarrouselVariant.LIGHT },
        )}
        onClick={handleClick}
      >
        <i className="whl-icon wh-icon-arrow-line-left whl-flex whl-h-[40px] whl-w-[40px] whl-items-center whl-justify-center whl-rounded-full whl-border whl-text-xl" />
      </button>
    );
  };

  const SlideNextButton = () => {
    const swiper = useSwiper();
    const handleClick = () => {
      if (swiper.isEnd) {
        swiper.slideTo(0);
      } else {
        swiper.slideNext();
      }
    };
    return (
      <button
        type="button"
        className={clsx(
          'whl-pointer-events-auto whl-transition-all  hover:whl-opacity-75',
          { 'whl-text-blue-dark': variant === MktCarrouselVariant.DARK },
          { 'whl-text-white': variant === MktCarrouselVariant.LIGHT },
        )}
        onClick={handleClick}
      >
        <i className="whl-icon wh-icon-arrow-line-right whl-flex whl-h-[40px] whl-w-[40px] whl-items-center whl-justify-center whl-rounded-full whl-border whl-text-xl" />
      </button>
    );
  };

  return (
    <div
      className={clsx(
        'whl-flex whl-flex-row whl-items-center whl-justify-center whl-gap-5 !whl-pt-3',
        {
          'lg:whl-justify-center': elements.length === 1,
        },
        {
          'lg:whl-justify-around': elements.length === 2,
        },
      )}
    >
      {(isDesktop || isTablet) && elements.length <= 2 ? (
        elements.map((element, i) => {
          return (
            <div
              key={i}
              className="whl-flex whl-w-full whl-justify-center !whl-py-3 "
            >
              {element}
            </div>
          );
        })
      ) : (
        <Swiper
          slidesPerView={getSliderPerView()}
          className="whl-relative whl-w-full !whl-pb-[70px]"
        >
          {elements.map((element, i) => {
            return (
              <SwiperSlide
                key={i}
                className={clsx('!whl-flex whl-w-full whl-justify-center')}
              >
                <div className="whl-flex whl-w-full whl-justify-center ">
                  {element}
                </div>
              </SwiperSlide>
            );
          })}
          <div className="whl-pointer-events-none whl-absolute whl-bottom-0 whl-z-[9999] whl-flex whl-w-full whl-items-center whl-justify-center whl-gap-5 whl-px-[5px]">
            <SlidePrevButton />
            <SlideNextButton />
          </div>
        </Swiper>
      )}
    </div>
  );
};
